import { useState } from 'react';

export const useFilteringAndSorting = ({ params, setParams }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [isSortingOpen, setIsSortingOpen] = useState(false);

  const handleFilterMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setIsFiltersOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleSortMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setIsSortingOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const sortingArray = [
    {
      id: 1,
      name: 'Created At',
      onClick: () => handleSortOptionSelect('createdAt'),
      value: 'createdAt',
    },
    {
      id: 2,
      name: 'Updated At',
      onClick: () => handleSortOptionSelect('updatedAt'),
      value: 'updatedAt',
    },
  ];

  const handleSortOptionSelect = (field: 'createdAt' | 'updatedAt') => {
    setParams({ ...params, sortBy: field });
  };

  const handleSortOrderChange = (val: 'asc' | 'desc' | string) => {
    setParams({ ...params, sortOrder: val });
  };

  const handleResetFilter = () => {
    setParams({ ...params, filters: {} });
    setIsFiltersOpen(false);
  };

  return {
    anchorEl,
    isFiltersOpen,
    isSortingOpen,
    handleFilterMenuClick,
    handleSortMenuClick,
    sortingArray,
    handleSortOrderChange,
    setAnchorEl,
    setIsSortingOpen,
    setIsFiltersOpen,
    handleResetFilter,
  };
};
